// 简单的API前缀配置
export const API_PREFIXES = {
  AUTH: '/api/auth',
  FACTORY: '/api/factory',
  STATS: '/api/stats',
  ADMIN: '/api/admin',
  PROXY: '/api',
};
